import { Row, Col, Card } from 'antd';
import CostsTab from '../media-plan/components/CostsTab';
import React, { useEffect, useState, useRef, useCallback } from "react";
 

const CostsPage = () => {

  
 

 
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Row>
          <Col span={24}>
            <Card title="Costs Management" bordered={false}>
              <CostsTab />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CostsPage;
